import {AbstractReactComponent, i18n} from 'mc/lib';
import {CustomSelect} from 'mc/lib/field';
import {objectById, storeFromArea} from 'mc/lib/utils';
import React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Alert, Card, Col, FormGroup, Input, Row} from 'reactstrap';
import {formValueSelector, propTypes, reduxForm} from 'redux-form';
import {CurrentZadostActions, TypZaborListActions} from '../../actions';
import {Api} from '../../api';
import {getOuterHeight} from '../../utils';
import {Loading} from '../common';
import {TypZaborDetail, TypZaborListItem} from '../zabor';
import ZadostBackButton from './ZadostBackButton';
import ZadostFooter from './ZadostFooter';
import ZadostLayout from './ZadostLayout';
import ZadostNextButton from './ZadostNextButton';
import './ZadostTyp.scss';

class ZadostTyp extends AbstractReactComponent {

    static formName = 'zadostTyp';

    static propTypes = {
        ...propTypes,
    };

    static validate = values => {
        const errors = {};
        if (values.idTypZabor === null) {
            errors.idTypZabor = i18n('zadostTyp.typZaborPrompt');
        }
        return errors;
    };

    state : {id: number, readMode: boolean} = {id:parseInt(this.props.params.id), readMode: !isNaN(parseInt(this.props.params.id))};

    componentDidMount() {
        const {readMode, id} = this.state;
        if (readMode) {
            this.dispatch(CurrentZadostActions.fetchIfNeeded(id, true, true, false));
        }
        this.dispatch(TypZaborListActions.fetchIfNeeded());
        this.setState({listHeight: this.getListHeight()});
    }

    componentDidUpdate() {
        this.dispatch(TypZaborListActions.fetchIfNeeded());

        if (!this.state.readMode) {
            const {idTypZabor, typZaborList, change} = this.props;
            if (!idTypZabor && typZaborList.fetched && typZaborList.filteredRows && typZaborList.filteredRows.length) {
                change('idTypZabor', typZaborList.filteredRows[0].id)
            }
        }
    }

    componentWillUnmount() {
        this.dispatch(CurrentZadostActions.invalidate())
    }

    getListHeight() {
        if (window.innerWidth < 768) {
            return null;
        }

        const header = document.getElementById('header');
        const heading = document.getElementById('heading');
        const stage = document.getElementById('stage');
        const filter = document.getElementById('filter');
        const footer = document.getElementById('footer');

        const headerHeight = getOuterHeight(header);
        const stageHeight = stage ? stage.offsetHeight : 40;
        const headingHeight = heading ? getOuterHeight(heading) : 70;
        const filterHeight = filter ? filter.offsetHeight : 40;
        const footerHeight = footer ? footer.offsetHeight : 50;

        return window.innerHeight - headerHeight - stageHeight - headingHeight - filterHeight - footerHeight - 60;
    }

    submit = (data) => {
        if (this.state.readMode) {
            return this.nextStep(this.state.id);
        }
        return Api.createZadost(data.idTypZabor).then(res => {
            this.nextStep(res.id);
        });
    };

    nextStep = (id: number) => {
        browserHistory.push(serverContextPath + '/zadost/' + id + '/nalezitosti');
    };

    handleFilterTypZabor = event => {
        this.dispatch(TypZaborListActions.filter(event.target.value));
    };

    handleTypZaborChange = id => {
        this.props.change('idTypZabor', id);
    };

    renderDetail() {
        const {idTypZabor, typZaborList, zadost} = this.props;
        const {readMode} = this.state;

        if (readMode) {
            return <TypZaborDetail typZabor={zadost.typZabor}/>;
        }

        if (idTypZabor) {
            const typZabor = objectById(typZaborList.rows, idTypZabor);
            if (typZabor) {
                return <TypZaborDetail typZabor={typZabor}/>;
            }
        }

        return null;
    }

    render() {
        const {handleSubmit, typZaborList, idTypZabor, zadost} = this.props;
        const {readMode, listHeight} = this.state;

        if (this.state.readMode && !zadost) {
            return <Loading block="full"/>;
        }

        const listStyle = {
            maxHeight: listHeight ? listHeight + 'px' : 'auto',
            overflowY:'auto'
        };

        const submitFunction = handleSubmit(this.submit);
        const emptyList = !readMode && typZaborList.filteredRows.length === 0;

        return <ZadostLayout className="zadost-typ" stage={1}>
            <Row>
                <Col xs={12}>
                    <h1 id="heading">{i18n('zadostTyp.title')}</h1>
                    {!readMode && (
                        <FormGroup id="filter">
                            <Input type="text"
                                   value={typZaborList.filter.text || ''}
                                   onChange={this.handleFilterTypZabor}
                                   placeholder={i18n('zadostTyp.searchHint')} />
                        </FormGroup>
                    )}
                    <Row>
                        {emptyList && (
                            <Col xs={12} md={6}>
                                <Alert color="info">{i18n('typZabor.emptyList')}</Alert>
                            </Col>
                        )}
                        {!emptyList && (
                            <Col xs={12} md={6}>
                                <form onSubmit={submitFunction}>
                                    <Card block style={listStyle}>
                                        <CustomSelect name="typZabor"
                                                      className="typ-zabor"
                                                      field={CustomSelect}
                                                      value={idTypZabor}
                                                      items={readMode ? [zadost.typZabor] : typZaborList.filteredRows}
                                                      disabled={readMode}
                                                      renderItem={TypZaborListItem.renderListItem}
                                                      onChange={this.handleTypZaborChange}
                                                      required/>
                                    </Card>
                                </form>
                            </Col>
                        )}
                        {!emptyList && (
                            <Col xs={12} md={6}>
                                {this.renderDetail()}
                            </Col>
                        )}
                    </Row>
                    <ZadostFooter>
                        <ZadostBackButton path=""/>
                        <ZadostNextButton type="submit" disabled={!readMode && !idTypZabor} onClick={submitFunction} />
                    </ZadostFooter>
                </Col>
            </Row>
        </ZadostLayout>
    }
}

const formConfig = {
    form: ZadostTyp.formName,
};

const selectFormValue = formValueSelector(ZadostTyp.formName);

const mapStateToProps = state => {
    const {app: {currentZadost: {data}}} = state;
    return {
        zadost: data,
        initialValues: data ? {typZabor: data.typZabor.id} : null,
        typZaborList: storeFromArea(state, 'typZaborList'),
        idTypZabor: selectFormValue(state, 'idTypZabor')
    };
};

const connectState = connect(mapStateToProps);
const connectForm = reduxForm(formConfig);

export default connectState(connectForm(ZadostTyp));
